// components/MyPage/HistoryStyles.js
export const tablePaperSX = { overflowX: 'auto', borderRadius: 2 };
export const tableHeadCellSX = { fontWeight: 600, whiteSpace: 'nowrap' };
